var classList = require('dom-classlist');
var pubsub = require('pubsub');
var gsap = require('gsap');
var Swiper = require('swiper');

module.exports = function () {

	pubsub.on('slider:init', function(elem){
		var _slider = elem.querySelector('.swiper-container-bloc');
		if(!_slider) return;
		var _slides = _slider.querySelectorAll('.swiper-slide');

		if(_slides.length <= 1){
			//hide prec & suiv button
			_slider.querySelector('nav').style.display = 'none';
			return;
		}

		swiper = new Swiper (_slider, {
			direction: 'horizontal',
			slidesPerView:1,
			threshold: 30,
			nextButton: '.next',
			prevButton: '.prev',
		})

	})
	return;
}
